<script>

  import {mapGetters} from 'vuex'

  export default {
    name: 'Msg',

    props: ['id', 'cssClass', 'skipWrapper'],

    computed: {
      ...mapGetters(['getLabel']),

      message: function () {
        return this.getLabel(this.id)
      },
    }
  }
</script>

<template>
  <span :class="{cssClass}">{{message}}</span>
</template>